<ng-select
  #select
  class="w-full tabular-nums"
  [(ngModel)]="pivotValue"
  [items]="options"
  [clearable]="true"
  bindLabel="label"
  bindValue="value"
  [compareWith]="compareArrays"
  appendTo="body"
  [searchFn]="searchFn"
>
  <ng-template ng-option-tmp let-item="item" let-index="item">
    @if (!item.value.length) {
      <div class="pr-4 text-sm leading-5">
        {{ zeroHyphen }}
      </div>
    } @else {
      <div class="pr-4 text-sm leading-5">
        {{ item.label }}
      </div>
    }
  </ng-template>
</ng-select>
